export default {
  activity_tutorial_01: {
    title: 'Jeg gjennomførte en klimavennlig aktivitet i dag',
    description: 'Registreres hver gang du gjør noe bra for planeten!	',
  },
};
